import {Tag} from '../../../../types';
import TagNode from '../../../Ui/TagNode';
import assetClasses from '../../../AssetList/classes';
import {useTranslation} from 'react-i18next';

// Number of tags shown before collapsing the rest into a "+N" chip.
const tagsLimit = 1;

type Props = {
    tags: Tag[];
};

export default function AssetTagList({tags}: Props) {
    const {t} = useTranslation();

    const r = (c: Tag) => (
        <TagNode
            size={'small'}
            key={c.id}
            name={c.displayName}
            color={c.color}
        />
    );

    const rest = tags.length - (tagsLimit - 1);
    const others =
        tagsLimit > 1
            ? t('asset.tag_list.others', {
                  defaultValue: `+ {{count}} other`,
                  defaultValue_other: `+ {{count}} others`,
                  count: rest,
              })
            : t('asset.tag_list.tags', {
                  defaultValue: `+ {{count}} tag`,
                  defaultValue_other: `+ {{count}} tags`,
                  count: rest,
              });
    const chips =
        tags.length <= tagsLimit
            ? tags.slice(0, tagsLimit).map(r)
            : [
                  tags.slice(0, tagsLimit - 1).map(r),
                  [
                      <TagNode
                          key={'o'}
                          size={'small'}
                          name={others}
                          color={'#DDD'}
                          title={tags
                              .slice(tagsLimit - 1)
                              .map(c => c.name)
                              .join('\n')}
                      />,
                  ],
              ].flat();

    return <div className={assetClasses.tagList}>{chips}</div>;
}

export function tagListSx() {
    return {
        [`.${assetClasses.tagList}`]: {
            display: 'flex',
            gap: 0.5,
            alignItems: 'center',
            flexWrap: 'wrap',
        },
    };
}
